// extracted by mini-css-extract-plugin
module.exports = {"gorseYellowOrange":"#ff9800","denimBlue":"#2f6177"};